// extracted by mini-css-extract-plugin
module.exports = {"UserMenu":"UserMenu_UserMenu__3Ajia","UserName":"UserMenu_UserName__2mbgC","Name":"UserMenu_Name__1FDje","btn":"UserMenu_btn__3eAbC"};